import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Icon from 'builder/components/Icon'
import { foldableSectionMixin } from 'builder/components/Section'

export const Container = styled.div`
  position: relative;
  ${foldableSectionMixin}
`

export const ShowButton = styled.div`
  ${Typography.Caption};
  font-weight: 600;
  color: ${Colors.Blue50};
  cursor: pointer;
  display: inline-block;

  &:hover {
    color: ${Colors.Blue70};
  }
`

export const ShowButtonText = styled.span`
  display: inline-block;
  vertical-align: middle;
`

export const ShowButtonIcon = styled(Icon.ToggleArrow)`
  display: inline-block;
  vertical-align: middle;
  transform: rotate(90deg);

  &[data-open='true'] {
    transform: translateY(2px) rotate(-90deg);
  }
`

export const AdditionalFields = styled.div`
  padding-bottom: 24px;
`
